module.exports = __webpack_public_path__ + "static/media/dotted-square-light.dd22796a.svg";